module.exports = __webpack_public_path__ + "371f393ccaff83f5bcf52775acf41df5.svg";